var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 91,
    viewBox: "0 0 88 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4575 17.3929L24.294 23.307C15.892 25.4522 12.3182 31.3889 14.5769 39.4212L22.2269 66.6257C24.5227 74.7897 30.7032 78.1231 39.1052 75.9779L62.2688 70.0638C70.8062 67.884 74.2714 62.0879 71.9757 53.9239L64.3257 26.7194C62.067 18.6871 55.995 15.2131 47.4575 17.3929Z",
    fill: "url(#paint0_linear_9523_64919)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9523_64919)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.33,
    height: 31.1951,
    rx: 14,
    transform: "matrix(-0.270704 -0.962662 0.968918 -0.247383 33.6074 66.4878)",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_9523_64919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2397 31.4707H45.259C36.5606 31.4707 31.4961 36.3238 31.4961 44.6394V72.8036C31.4961 81.2556 36.5606 85.9997 45.259 85.9997H69.2397C78.0783 85.9997 82.9998 81.2556 82.9998 72.8036V44.6394C82.9998 36.3238 78.0783 31.4707 69.2397 31.4707Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2397 30.9707H45.259C40.8192 30.9707 37.2408 32.2104 34.7699 34.5755C32.2961 36.9435 30.9961 40.3787 30.9961 44.6394V72.8036C30.9961 77.1305 32.295 80.5741 34.7707 82.9331C37.2429 85.2888 40.8221 86.4997 45.259 86.4997H69.2397C73.7449 86.4997 77.3252 85.2897 79.7806 82.9318C82.239 80.5709 83.4998 77.1266 83.4998 72.8036V44.6394C83.4998 40.3827 82.2379 36.9466 79.7814 34.5768C77.3273 32.2095 73.7478 30.9707 69.2397 30.9707Z",
    stroke: "url(#paint1_linear_9523_64919)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_9523_64919)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_9523_64919",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0314 44.1497V44.1769C44.7981 44.1769 43.7995 45.1312 43.7995 46.3036C43.7995 47.4759 44.7981 48.4302 46.0314 48.4302H54.5838C55.8171 48.4302 56.8185 47.4759 56.8185 46.2736C56.8185 45.1039 55.8171 44.1497 54.5838 44.1497H46.0314ZM68.4641 60.7542H46.0314C44.7981 60.7542 43.7995 59.8 43.7995 58.6276C43.7995 57.4552 44.7981 56.4982 46.0314 56.4982H68.4641C69.6944 56.4982 70.6959 57.4552 70.6959 58.6276C70.6959 59.8 69.6944 60.7542 68.4641 60.7542ZM68.4643 73.2139H46.0316C45.1732 73.3229 44.3434 72.914 43.8856 72.2324C43.4278 71.5235 43.4278 70.6238 43.8856 69.9421C44.3434 69.2333 45.1732 68.8516 46.0316 68.9334H68.4643C69.606 69.0424 70.4672 69.9694 70.4672 71.0872C70.4672 72.1751 69.606 73.1048 68.4643 73.2139Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0314 44.1497V44.1769C44.7981 44.1769 43.7995 45.1312 43.7995 46.3036C43.7995 47.4759 44.7981 48.4302 46.0314 48.4302H54.5838C55.8171 48.4302 56.8185 47.4759 56.8185 46.2736C56.8185 45.1039 55.8171 44.1497 54.5838 44.1497H46.0314ZM68.4641 60.7542H46.0314C44.7981 60.7542 43.7995 59.8 43.7995 58.6276C43.7995 57.4552 44.7981 56.4982 46.0314 56.4982H68.4641C69.6944 56.4982 70.6959 57.4552 70.6959 58.6276C70.6959 59.8 69.6944 60.7542 68.4641 60.7542ZM68.4643 73.2139H46.0316C45.1732 73.3229 44.3434 72.914 43.8856 72.2324C43.4278 71.5235 43.4278 70.6238 43.8856 69.9421C44.3434 69.2333 45.1732 68.8516 46.0316 68.9334H68.4643C69.606 69.0424 70.4672 69.9694 70.4672 71.0872C70.4672 72.1751 69.606 73.1048 68.4643 73.2139Z",
    fill: "url(#paint2_linear_9523_64919)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0314 44.1769V44.5769H46.4314V44.1769H46.0314ZM46.0314 44.1497V43.7497H45.6314V44.1497H46.0314ZM46.0316 73.2139V72.8139H46.0063L45.9812 72.8171L46.0316 73.2139ZM68.4643 73.2139V73.6139H68.4834L68.5023 73.6121L68.4643 73.2139ZM43.8856 72.2324L43.5495 72.4494L43.5535 72.4554L43.8856 72.2324ZM43.8856 69.9421L44.2177 70.1652L44.2216 70.1591L43.8856 69.9421ZM46.0316 68.9334L45.9936 69.3316L46.0126 69.3334H46.0316V68.9334ZM68.4643 68.9334L68.5023 68.5352L68.4834 68.5334H68.4643V68.9334ZM46.4314 44.1769V44.1497H45.6314V44.1769H46.4314ZM44.1995 46.3036C44.1995 45.3697 45.001 44.5769 46.0314 44.5769V43.7769C44.5953 43.7769 43.3995 44.8926 43.3995 46.3036H44.1995ZM46.0314 48.0302C45.001 48.0302 44.1995 47.2374 44.1995 46.3036H43.3995C43.3995 47.7145 44.5953 48.8302 46.0314 48.8302V48.0302ZM54.5838 48.0302H46.0314V48.8302H54.5838V48.0302ZM56.4185 46.2736C56.4185 47.2403 55.6112 48.0302 54.5838 48.0302V48.8302C56.0229 48.8302 57.2185 47.7116 57.2185 46.2736H56.4185ZM54.5838 44.5497C55.6153 44.5497 56.4185 45.3435 56.4185 46.2736H57.2185C57.2185 44.8644 56.0189 43.7497 54.5838 43.7497V44.5497ZM46.0314 44.5497H54.5838V43.7497H46.0314V44.5497ZM46.0314 61.1542H68.4641V60.3542H46.0314V61.1542ZM43.3995 58.6276C43.3995 60.0385 44.5953 61.1542 46.0314 61.1542V60.3542C45.001 60.3542 44.1995 59.5614 44.1995 58.6276H43.3995ZM46.0314 56.0982C44.5946 56.0982 43.3995 57.2173 43.3995 58.6276H44.1995C44.1995 57.6931 45.0017 56.8982 46.0314 56.8982V56.0982ZM68.4641 56.0982H46.0314V56.8982H68.4641V56.0982ZM71.0959 58.6276C71.0959 57.217 69.8976 56.0982 68.4641 56.0982V56.8982C69.4913 56.8982 70.2959 57.6935 70.2959 58.6276H71.0959ZM68.4641 61.1542C69.8969 61.1542 71.0959 60.0388 71.0959 58.6276H70.2959C70.2959 59.5611 69.492 60.3542 68.4641 60.3542V61.1542ZM46.0316 73.6139H68.4643V72.8139H46.0316V73.6139ZM43.5535 72.4554C44.092 73.257 45.0669 73.7396 46.082 73.6107L45.9812 72.8171C45.2794 72.9062 44.5948 72.5709 44.2176 72.0093L43.5535 72.4554ZM43.5535 69.7191C43.0034 70.5382 43.0082 71.6111 43.5496 72.4494L44.2216 72.0153C43.8474 71.4359 43.8522 70.7093 44.2176 70.1652L43.5535 69.7191ZM46.0695 68.5352C45.0713 68.44 44.0931 68.8835 43.5496 69.7251L44.2216 70.1591C44.5937 69.583 45.2751 69.2631 45.9936 69.3316L46.0695 68.5352ZM68.4643 68.5334H46.0316V69.3334H68.4643V68.5334ZM70.8672 71.0872C70.8672 69.7552 69.8412 68.6631 68.5023 68.5352L68.4263 69.3315C69.3708 69.4218 70.0672 70.1836 70.0672 71.0872H70.8672ZM68.5023 73.6121C69.8383 73.4844 70.8672 72.3921 70.8672 71.0872H70.0672C70.0672 71.9581 69.3737 72.7252 68.4263 72.8157L68.5023 73.6121Z",
    fill: "url(#paint3_linear_9523_64919)",
    mask: "url(#path-5-inside-1_9523_64919)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9523_64919",
    x: 0.310303,
    y: 0.781982,
    width: 87.2557,
    height: 89.6836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5,
    result: "effect1_foregroundBlur_9523_64919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_9523_64919",
    x: 6.49609,
    y: 6.4707,
    width: 101.504,
    height: 104.529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9523_64919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9523_64919",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_9523_64919",
    x: 28.5422,
    y: 29.1497,
    width: 57.1537,
    height: 59.0818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9523_64919"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_9523_64919",
    result: "effect2_dropShadow_9523_64919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9523_64919",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9523_64919",
    x1: 35.8744,
    y1: 20.3503,
    x2: 49.4057,
    y2: 73.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9523_64919",
    x1: 39.6946,
    y1: 37.8234,
    x2: 74.844,
    y2: 78.9415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9523_64919",
    x1: 68.7707,
    y1: 49.4012,
    x2: 38.52,
    y2: 50.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9523_64919",
    x1: 47.8647,
    y1: 47.5377,
    x2: 66.6432,
    y2: 69.2534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.15be09dce2edc7cd30c7ef20f6a5074c.svg";
export { ForwardRef as ReactComponent };